import { render, staticRenderFns } from "./SecurityLayout.vue?vue&type=template&id=dd19a3e6&scoped=true"
import script from "./SecurityLayout.vue?vue&type=script&lang=js"
export * from "./SecurityLayout.vue?vue&type=script&lang=js"
import style0 from "./SecurityLayout.vue?vue&type=style&index=0&id=dd19a3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd19a3e6",
  null
  
)

export default component.exports